import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../services/data.service";
import {RouterLink} from "@angular/router";
import {DatePipe, NgIf} from "@angular/common";
import {PaginationComponent} from "ngx-bootstrap/pagination";
import {FormsModule} from "@angular/forms";
import {StoreTokenTestComponent} from "../../components/store-token-test.component";

@Component({
    selector: 'app-store-list',
    imports: [RouterLink, NgIf, DatePipe, PaginationComponent, FormsModule, StoreTokenTestComponent],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-store me-2"></i>Stores <small class="text-muted">({{ storesRunning}} in Betrieb, {{ storesPlanned }} in Planung)</small></h3>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6">
                        <button type="button" class="btn btn-primary me-2" [routerLink]="['/store', 0]">Store anlegen</button>
                    </div>
                    <div class="col-md-6 text-end">
                        <div class="form-check form-check-inline mt-2 me-3">
                            <input class="form-check-input" type="checkbox" id="showTakenOver" [(ngModel)]="search.showTakenOver" (change)="checkFilterAndList()">
                            <label class="form-check-label" for="showTakenOver">Übernommene Stores anzeigen</label>
                        </div>
                        <app-store-token-test />
                        <button type="button" class="btn btn-outline-secondary" (click)="exportCSV()">
                            <i class="fa-solid fa-file-csv me-1"></i>CSV exportieren
                        </button>
                    </div>
                </div>

                <pagination
                    [hidden]="entries?.length == 0"
                    [totalItems]="totalEntries"
                    [itemsPerPage]="paginConfig.itemsPerPage"
                    [(ngModel)]="paginConfig.page"
                    (pageChanged)="listEntries($event)"
                    [maxSize]="20"
                    previousText="Letzte"
                    nextText="Nächste">
                </pagination>

                <div class="table-responsive">
                    <table *ngIf="entries?.length > 0" class="table table-striped table-hover mb-0 pointer">
                        <thead>
                        <tr>
                            <th (click)="setOrder('name')">
                                Name <i class="fa-solid" *ngIf="predicate == 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('country')">
                                Land <i class="fa-solid" *ngIf="predicate == 'country'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('city')">
                                Ort <i class="fa-solid" *ngIf="predicate == 'city'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('region')">
                                Region <i class="fa-solid" *ngIf="predicate == 'region'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('position')">
                                Lage <i class="fa-solid" *ngIf="predicate == 'position'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('area')">
                                Größe (m²) <i class="fa-solid" *ngIf="predicate == 'area'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('date_opened')">
                                Datum Eröffnet <i class="fa-solid" *ngIf="predicate == 'date_opened'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('franchisee')">
                                Franchisenehmer <i class="fa-solid" *ngIf="predicate == 'franchisee'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('contact')">
                                Kontakt <i class="fa-solid" *ngIf="predicate == 'contact'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('phone')">
                                Telefon <i class="fa-solid" *ngIf="predicate == 'phone'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('email')">
                                E-Mail <i class="fa-solid" *ngIf="predicate == 'email'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        @for (entry of entries; track entry.id) {
                            <tr [routerLink]="['/store', entry.id]">
                                <td>
                                    <i class="fa-solid fa-circle text-success me-2" *ngIf="entry.account_token"></i>
                                    <i class="fa-solid fa-circle text-danger me-2" *ngIf="!entry.account_token"></i>
                                    {{ entry.name }}
                                </td>
                                <td>{{ entry.country }}</td>
                                <td>{{ entry.city }}</td>
                                <td>{{ entry.region }}</td>
                                <td>{{ entry.position }}</td>
                                <td>{{ entry.area }}</td>
                                <td>{{ entry.date_opened | date: "dd.MM.yyyy" }}</td>
                                <td>{{ entry.franchisee }}</td>
                                <td>{{ entry.contact }}</td>
                                <td>
                                    @if (entry.phone) {
                                        <a (click)="$event.stopPropagation()" [href]="'tel:' + entry.phone">{{ entry.phone }}</a>
                                        <a class="ms-3" (click)="$event.stopPropagation()" [href]="'https://wa.me/' + entry.phone"><i class="fa-brands fa-whatsapp text-success"></i></a>
                                    }
                                </td>
                                <td>
                                    @if (entry.email) { <a (click)="$event.stopPropagation()" [href]="'mailto:' + entry.email"><i class="fa-solid fa-envelope"></i></a> }
                                </td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `
})
export class StoreListComponent implements OnInit {

    private dataService = inject(DataService);

    paginConfig: any = {
        itemsPerPage: 25,
        page: 1
    };
    entries!: any[]|null;
    totalEntries = 0;
    predicate = 'name';
    search: any = {
        text: '',
        showTakenOver: false
    };
    reverse = false;

    storesRunning = 0;
    storesPlanned = 0;

    ngOnInit(): void {
        this.listEntries(this.paginConfig);
    }

    setOrder(order: string): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event: any): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('Store/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            filter: this.search.text,
            showTakenOver: this.search.showTakenOver,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.stores;

            this.storesRunning = response.stats.storesRunning;
            this.storesPlanned = response.stats.storesPlanned;
        });
    }

    exportCSV(): void {
        this.dataService.request('Store/exportCSV').subscribe(response => {
            if (response && response.file) {
                this.dataService.generateBlob(response);
            }
        });
    }

}
